var _g, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMapLayersIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3695_5406)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 16,
    width: 40,
    height: 40,
    rx: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.5,
    y: 16.5,
    width: 39,
    height: 39,
    rx: 3.5,
    stroke: "#FAFAFA"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3695_5406)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.1419 36.4931L32.3443 32.8175C31.8853 32.6009 31.8853 31.9481 32.3443 31.7321L40.1419 28.0571C40.3039 27.9809 40.4917 27.9809 40.6537 28.0571L48.4513 31.7321C48.9103 31.9487 48.9103 32.6015 48.4513 32.8175L40.6537 36.4925C40.4917 36.5694 40.3039 36.5694 40.1419 36.4931Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.4525 35.3337L47.0533 34.6719L41.1145 37.4709C40.8931 37.5753 40.6447 37.6311 40.3981 37.6311C40.1521 37.6311 39.9037 37.5753 39.6811 37.4703L33.7447 34.6725L32.3491 35.3337C31.8871 35.5497 31.8871 36.2037 32.3491 36.4197L40.1431 40.0917C40.3051 40.1697 40.4971 40.1697 40.6591 40.0917L48.4531 36.4197C48.9139 36.2037 48.9139 35.5497 48.4525 35.3337Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.4525 38.9327L47.0545 38.2715L41.1193 41.0675C40.9039 41.1713 40.6525 41.2295 40.4011 41.2295C40.1497 41.2295 39.8983 41.1719 39.6727 41.0633L33.7471 38.2715L32.3491 38.9327C31.8871 39.1487 31.8871 39.8027 32.3491 40.0187L40.1431 43.6907C40.3051 43.7687 40.4971 43.7687 40.6591 43.6907L48.4531 40.0187C48.9139 39.8027 48.9139 39.1487 48.4525 38.9327Z",
    fill: "#666666"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3695_5406",
    x: 0,
    y: 0,
    width: 80,
    height: 80,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3695_5406"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3695_5406",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3695_5406"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(28 24)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapLayersIcon);
export default __webpack_public_path__ + "static/media/MapLayersIcon.854f8e2de16690571ad955595a54cd11.svg";
export { ForwardRef as ReactComponent };